import { useAppDisplayModeContext } from '@archipro-design/aria';
import RecentlyViewedDesktop from './RecentlyViewed.desktop';
import RecentlyViewedMobile from './RecentlyViewed.mobile';

import SwiperCore from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { useFetcher } from '@remix-run/react';

import type { LoaderResult } from '~/routes/remix-api.articles.get-recently-viewed-articles';
import { HREF_RECENTLY_VIEWED_ARTICLES } from '~/routes/remix-api.articles.get-recently-viewed-articles';
import { useEffect } from 'react';

import { useSaveToDesignBoard } from '~/modules/design-board/hook/use-save-to-design-board';
import SaveToDesignBoard from '@modules/design-board/component/SaveToDesignBoard';
import { fetcherIsInit } from '~/utils/fetcherHelper';

SwiperCore.use([Navigation, Pagination]);

const RecentlyViewed: React.FC = () => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const { favouriteItem } = useSaveToDesignBoard('ArticlePin');
    const fetcher = useFetcher<LoaderResult>();
    const recentlyViewed = fetcher.data?.recentlyViewedArticles ?? [];

    useEffect(() => {
        if (fetcherIsInit(fetcher)) {
            fetcher.load(HREF_RECENTLY_VIEWED_ARTICLES);
        }
    }, [fetcher]);

    const args = {
        recentlyViewed,
        favouriteItem,
    };

    if (!recentlyViewed?.length) return null;

    return (
        <>
            {isMobile ? (
                <RecentlyViewedMobile {...args} />
            ) : (
                <RecentlyViewedDesktop {...args} />
            )}
            {favouriteItem.target && (
                <SaveToDesignBoard {...favouriteItem} autoReposition={false} />
            )}
        </>
    );
};

export default RecentlyViewed;
